import { useEffect, useState } from 'react';
import styles from './style.module.css';
import Sidebar from './Sidebar';
import TotalAcc from './TotalAcc';
import useApi from '../../services/useApi';
import TestsetList from './TestsetList';
import { COLORS } from './constant';

export default function TaskEval(){
    const [isListLoad,setIsListLoad]=useState(true);
    const [modelList,]=useState([]);
    const [taskList,setTaskList]=useState([]);
    const [testsetList,setTestsetList]=useState([]);
    const [checkedModels,]=useState([]);
    const [checkedTasks,setCheckedTasks]=useState([]);
    const [checkedTest,setCheckedTest]=useState(null);
    const [dashboardData,setDashboardData]=useState([]);
    const [chartData,setChartData]=useState([]);
    const [toggle,setToggle]=useState('precision');

    const loadList=()=>{
        setIsListLoad(true)
        useApi.get('backboard/task-evaluation/batches').then((res)=>{
            setTaskList(res.data);
            setIsListLoad(false)
            setCheckedTasks([res.data.map(item=>item.batchId)[0]]);
        }).catch(function (thrown) {
        });
        useApi.get('backboard/datasets/dashboards').then((res)=>{
            setTestsetList(res.data);
            setCheckedTest(res.data[0]);
        }).catch(function (thrown) {
        });
    }

    useEffect(()=>{
        loadList();
    },[])

    useEffect(()=>{
        if(!checkedTest) return;

              useApi.get(`backboard/task-evaluation/batches/details`).then((res)=>{
                const newTaskData=[];
                res.data.map((taskData,i)=>{
      
                const matchedRounds = taskData.testList
                    .filter(test => test.datasetId === checkedTest.datasetId)
                    .sort((a, b) => a.roundNum - b.roundNum);
      
                const dataPoints = matchedRounds.map(item => {
                    const roundNum = item.roundNum;
                    const result = item.result;
      
                    const y = toggle === 'precision'
                      ? result?.precisionResult?.accuracy
                      : result?.thresholdResult?.accuracy;
      
                    const z = toggle === 'precision'
                      ? result?.precisionResult?.threshold
                      : result?.thresholdResult?.precision;

                    const r = toggle === 'precision'
                      ? result?.precisionResult?.precision
                      : result?.thresholdResult?.threshold;

                    return { x: roundNum, y, z, r };
                });
                const state=taskData.state==='COMPLETED'?
                'COMPLETED'
                :
                taskData.maxRound!==taskData.testList?.length?
                'Running'
                :
                'Pending'

                newTaskData.push({
                    taskName: taskData.taskName,
                    batchId:taskData.batchId,
                    taskId: taskData.taskId,
                    datasetId: checkedTest.datasetId,
                    data: dataPoints,
                    maxRound:taskList.find(obj=>obj.batchId===taskData.batchId).maxRound,
                    state:state
                    ,
                    color:state==='Running'?'#ff4d05':COLORS[i%COLORS.length],
                })
                })
                setDashboardData(newTaskData);
                setChartData(newTaskData.filter(obj=>checkedTasks.includes(obj.batchId)))
                })
                .catch(err => {
                    console.error(`Error fetching`, err);
                    return null;
                })
    },[checkedTasks,checkedTest,toggle])

    return(
        <div className={styles['wrap']}>
            <Sidebar
            isLoad={isListLoad}
            taskList={taskList}
            checkedTasks={checkedTasks}
            setCheckedTasks={setCheckedTasks}
            onChange={loadList}
            dashboardData={dashboardData}
            testsetList={testsetList}
            />
            <div className={styles['body']}>
                <header>
                    <span>Task Evaluation</span>
                </header>
                <TotalAcc
                dashboardData={chartData}
                modelList={modelList}
                checkedModels={checkedModels}
                testsetList={testsetList}
                checkedTest={checkedTest}
                toggle={toggle}
                setToggle={setToggle}
                />
            </div>
        </div>
    )
}